import jsPDF from "jspdf";
import "jspdf-autotable";

const generateTaxInvoice = (data) => {
    const doc = new jsPDF();

    // Header
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("TAX INVOICE", 105, 20, { align: "center" });

    // Sender Information (static)
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("From,", 14, 30);
    doc.setFont("helvetica", "bold");
    doc.text("Adspace LLC", 14, 35);
    doc.setFont("helvetica", "normal");
    doc.text(
        `Patricio Sanz 1701 Del Valle CDMX, Mexico`,
        14,
        40
    );
    doc.text("EMAIL: adspace.officials@gmail.com", 14, 55);

    // Receiver Information (from payment details)
    doc.text("To,", 140, 30);
    doc.setFont("helvetica", "bold");
    doc.text(data.publisherName || "", 140, 35); // fallback to empty if null
    doc.setFont("helvetica", "normal");
    doc.text(data.publisherAddress || "", 140, 40); // fallback to empty if null

    // Invoice Details (these could also come from data if needed)
    doc.setFontSize(10);
    doc.text(`Invoice Number: ${data.id || ""}`, 14, 80);
    doc.text(`Invoice Date: ${new Date(data.invoiceDate)
        .toLocaleDateString("en-GB") // gives "01/03/2025"
        .replace(/\//g, "-")}`, 14, 85);
    
    const currentMonth = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    doc.text(`Revenue Month: ${currentMonth}`, 14, 90);
    // Table Data
    // Removed "Rate" column, added "Deduction" column
    const tableColumn = ["Description", "Qty", "Deduction (US$)", "Amount (US$)"];
    const tableRows = [
        [
            data.description,
            "1",
            `${data.deductions || 0}`,  // Deduction
            `${data.revenue || 0}`     // Amount
        ],
    ];

    doc.autoTable({
        startY: 100,
        head: [tableColumn],
        body: tableRows,
        theme: "grid",
        styles: { halign: "center" },
    });

    // Footer Total Section
    const finalY = doc.lastAutoTable.finalY || 120;
    // For clarity, you can decide how to calculate totals:
    // e.g., subTotal = revenue, grandTotal = revenue - deductions, etc.
    const revenue = Number(data.revenue || 0);
    const deductions = Number(data.deductions || 0);
    const subTotal = revenue;              // if you want subTotal as the raw revenue
    const grandTotal = revenue - deductions;

    doc.setFont("helvetica", "bold");
    doc.text("Sub Total:", 160, finalY + 10, { align: "right" });
    doc.text(`${subTotal.toFixed(2)}`, 200, finalY + 10, { align: "right" });

    doc.text("Grand Total:", 160, finalY + 20, { align: "right" });
    doc.text(`${grandTotal.toFixed(2)}`, 200, finalY + 20, { align: "right" });

    // Footer Note
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
        `For ${data.publisherName}
        Please Remit the proceeds: By A/C payee cheque/dd in the name of ${data.publisherName}`,
        14,
        finalY + 40
    );

    // Bank Details (from data)
    doc.setFont("helvetica", "bold");
    doc.text("Bank Details:", 14, finalY + 50);
    doc.setFont("helvetica", "normal");
    doc.text(
        `Bank Name: ${data.bankName || ""}
Bank Account #: ${data.bankAccountNumber || ""}
Bank Branch: ${data.bankBranch || ""}
Swift Code: ${data.swiftCode || ""}`,
        14,
        finalY + 55
    );

    doc.setFont("helvetica", "italic");
    doc.text("*This invoice is system-generated. No signature is required.", 14, finalY + 90);

    // Save PDF
    doc.save("TaxInvoice.pdf");
};

export default generateTaxInvoice;
